/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Program,
    ProgramFromJSON,
    ProgramFromJSONTyped,
    ProgramToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetProgramResponse
 */
export interface GetProgramResponse {
    /**
     * 
     * @type {Program}
     * @memberof GetProgramResponse
     */
    program?: Program;
}

export function GetProgramResponseFromJSON(json: any): GetProgramResponse {
    return GetProgramResponseFromJSONTyped(json, false);
}

export function GetProgramResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProgramResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'program': !exists(json, 'program') ? undefined : ProgramFromJSON(json['program']),
    };
}

export function GetProgramResponseToJSON(value?: GetProgramResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program': ProgramToJSON(value.program),
    };
}


